"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.DISPLAY_NAME_TITLE_TEXT = exports.DISPLAY_NAME_TITLE = exports.DISPLAY_NAME_TABS = exports.DISPLAY_NAME_SIDEBAR = exports.DISPLAY_NAME_PAGE = exports.DISPLAY_NAME_MAIN = exports.DISPLAY_NAME_HEADER = exports.DISPLAY_NAME_FOOTER = exports.DISPLAY_NAME_BREADCRUMB = exports.DISPLAY_NAME_BODY = exports.DISPLAY_NAME_ALERT = exports.DISPLAY_NAME_ACTIONS = void 0;
var DISPLAY_NAME_ALERT = "OrionPageAlert";
exports.DISPLAY_NAME_ALERT = DISPLAY_NAME_ALERT;
var DISPLAY_NAME_PAGE = "OrionPage";
exports.DISPLAY_NAME_PAGE = DISPLAY_NAME_PAGE;
var DISPLAY_NAME_SIDEBAR = "OrionSidebar";
exports.DISPLAY_NAME_SIDEBAR = DISPLAY_NAME_SIDEBAR;
var DISPLAY_NAME_MAIN = "OrionPageMain";
exports.DISPLAY_NAME_MAIN = DISPLAY_NAME_MAIN;
var DISPLAY_NAME_HEADER = "OrionPageHeader";
exports.DISPLAY_NAME_HEADER = DISPLAY_NAME_HEADER;
var DISPLAY_NAME_FOOTER = "OrionPageFooter";
exports.DISPLAY_NAME_FOOTER = DISPLAY_NAME_FOOTER;
var DISPLAY_NAME_BREADCRUMB = "OrionBreadcrumb";
exports.DISPLAY_NAME_BREADCRUMB = DISPLAY_NAME_BREADCRUMB;
var DISPLAY_NAME_TITLE = "OrionPageHeaderTitle";
exports.DISPLAY_NAME_TITLE = DISPLAY_NAME_TITLE;
var DISPLAY_NAME_TITLE_TEXT = "OrionPageHeaderTitleText";
exports.DISPLAY_NAME_TITLE_TEXT = DISPLAY_NAME_TITLE_TEXT;
var DISPLAY_NAME_ACTIONS = "OrionPageHeaderActions";
exports.DISPLAY_NAME_ACTIONS = DISPLAY_NAME_ACTIONS;
var DISPLAY_NAME_BODY = "OrionPageBody";
exports.DISPLAY_NAME_BODY = DISPLAY_NAME_BODY;
var DISPLAY_NAME_TABS = "OrionPageTabs";
exports.DISPLAY_NAME_TABS = DISPLAY_NAME_TABS;